export enum MaskTypeEnum {
    Card = 'card',
    AccountNumber = 'account-number',
    Default = 'default',
}
